import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { FlexDivRow } from "./FlexDiv"
import Text from "./Text"

export const TextWithIconWrapper = styled(FlexDivRow)`
  margin-bottom: ${({ marginBottom }) => marginBottom && marginBottom};
  margin-top: ${({ marginTop }) => marginTop && marginTop};
  margin-left: ${({ marginLeft }) => marginLeft && marginLeft};
  justify-content: ${({ align }) => align && align};
`

/**
 * All of our different ways of showing text, from headlines to labels.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const TextWithIcon = (props): JSX.Element => {
  return (
    <TextWithIconWrapper {...props}>
      {props.icon}
      <Text {...props}>{props.children}</Text>
    </TextWithIconWrapper>
  )
}

TextWithIcon.propTypes = {
  textType: PropTypes.oneOf([
    "xl",
    "large",
    "small",
    "body",
    "smallText",
    "superSmall",
  ]).isRequired,
  icon: PropTypes.node,
  children: PropTypes.any,
  fontColor: PropTypes.oneOf(["white", "black", "gray_700", "gray_900"]),
  lineHeight: PropTypes.string,
  marginBottom: PropTypes.string,
  marginTop: PropTypes.string,
  marginLeft: PropTypes.string,
  align: PropTypes.string,
  fontWeight: PropTypes.oneOf(["500", "600", "700", "900"]),
  error: PropTypes.bool,
}

export default TextWithIcon
